const page = require('../../../../../components/page/page')
const suggestionPageHandler = require('./suggestion-page-handler')
const suggestionRightPage = require('./suggestion-page-right')

import suggestionPage from "./suggestion-page.html";

/****************ELEMENTS*****************/
var HTMLwasSelected = false

//insert the page  on the body
function HTMLselect(detail) { //console.log('suggestion init>')

   HTMLwasSelected = true

   //load the page to the index
   const body = document.body
   body.insertAdjacentHTML("beforeend", suggestionPage)

   suggestionPageHandler.init(detail)   
}/*init*/

/****************ELEMENTS*****************/

export function start(detail) { //console.log('suggestion page >', detail)

   if (!HTMLwasSelected) { HTMLselect(detail) }


   obj[detail.act].start(detail)
}

const obj = {
   show: { start: (detail) => { page.start(detail) } },
}/**/

